const colors = {
  mainDark: "#343152",
  mainLight: "#FFFFF7",
  orange: "#ff7600"
};

export default colors;
